import type {ReactElement} from 'react';
import type {ComponentStreamEvent} from '@Components/ai-chat-window/ai-chat-window.types';
import {ChatMessagePartType} from '@Components/ai-chat-window/ai-chat-window.types';
import type {ChatMessageComponentPart, StreamComponentContext, StreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {humanInputButtonsRegistration} from '@Components/ai-chat-window/components/human-input-buttons/human-input-buttons.registration';
import {planTableRegistration} from '@Components/ai-chat-window/components/plan-table/plan-table.registration';

const REGISTRATIONS: StreamComponentRegistration<StreamComponentType, unknown>[] = [
  planTableRegistration as StreamComponentRegistration<StreamComponentType, unknown>,
  humanInputButtonsRegistration as StreamComponentRegistration<StreamComponentType, unknown>,
];

const REGISTRY: Record<string, StreamComponentRegistration<StreamComponentType, unknown>> = REGISTRATIONS.reduce<Record<string, StreamComponentRegistration<StreamComponentType, unknown>>>(
  (acc, registration) => {
    acc[registration.componentType] = registration;
    return acc;
  },
  {}
);

export const createComponentPart = (event: ComponentStreamEvent): ChatMessageComponentPart | null => {
  const entry = REGISTRY[event.componentType];
  if (!entry) {
    return null;
  }

  return {
    type: ChatMessagePartType.COMPONENT,
    componentType: event.componentType,
    props: entry.parseProps(event.props),
  } as ChatMessageComponentPart;
};

export const renderStreamComponent = (part: ChatMessageComponentPart, context: StreamComponentContext): ReactElement | null => {
  const entry = REGISTRY[part.componentType];
  if (!entry) {
    return null;
  }
  return entry.render(part.props, context);
};
